import { Alert, List, Stack, Text, Title } from '@mantine/core';

export const ResetPassword = () => {
    return (
        <Stack gap="md">
            <Title order={3}>Reset Password</Title>

            <Alert color="yellow" title="SSO Users" mb="sm">
                If you sign in through your organization's Single Sign-On (SSO) provider, you cannot reset your password here.
                Please contact your organization's IT administrator to reset your password.
            </Alert>

            <Text>The steps below apply only to users who sign in with a username and password directly.</Text>

            <Title order={4} td="underline">How to Reset Your Password</Title>

            <List type="ordered" spacing="sm">
                <List.Item>Select your account on the sign-in screen</List.Item>
                <List.Item>Click "Forgot password?" on the password entry screen</List.Item>
                <List.Item>A verification code will be sent to your email address</List.Item>
                <List.Item>Enter the verification code and your new password</List.Item>
                <List.Item>Your password is now updated — you can sign in with your new password</List.Item>
            </List>

            <Title order={4} td="underline">Important Notes</Title>

            <List spacing="sm">
                <List.Item>The verification code expires after a short time. If it expires, request a new one.</List.Item>
                <List.Item>If you do not receive the email, check your spam or junk folder.</List.Item>
            </List>
        </Stack>
    );
};
